
// projects images
import Project1 from './assets/img/projects/todolist-ts_css.PNG';
import Project2 from './assets/img/projects/E_shop_scss.PNG';
import Project3 from './assets/img/projects/Blog-Scss.PNG';
import Project4 from './assets/img/projects/quiz-app-ts_styled-components.PNG';
import Project5 from './assets/img/projects/movie_app_bootstrap.PNG';
import Project6 from './assets/img/projects/Shooping-Cart_TS_styled-components.PNG';


// projects
export const projectsData = [
  {
    id: '1',
    image: Project1,
    name: 'TodoList',
    description: 'TodoList with react, typeScipt and css ',
    category: 'web development',
  },
  {
    id: '2',
    image: Project2,
    name: 'E-shop',
    description: 'E-shop with react.js and  Scss ',
    category: 'web development',
  },
  {
    id: '3',
    image: Project3,
    name: 'Blog',
    description: 'Blog with HTML and Scss ',
    category: 'web development',
  },

  {
    id: '4',
    image: Project4,
    name: 'Quiz App',
    description: 'Quiz App with React, typeScipt and Styled-Components ',
    category: 'web development',
  },
  {
    id: '5',
    image: Project5,
    name: 'Movie app',
    description: 'Movie app with react.js and bootstrap ',
    category: 'web development',
  },
  {
    id: '6',
    image: Project6,
    name: 'Shopping-Cart',
    description: 'Shopping-Cart with React, typeScript and Styled-Components ',
    category: 'web development',
  },
];

// projects
export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'UI/UX Design',
  },
  {
    name: 'web development',
  },
  
];




